import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "../Assets/lakenriver_logo-copy-2.webp";
import "../Styles/Navbar.css"; // Assuming you have a CSS file for additional styles
 
const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showActivities, setShowActivities] = useState(false);
 
  const navLinks = [
    { name: "Home", path: "/", active: true },
    { name: "About", path: "/about-us" },
    { name: "Escape Plan", path: "/escape-plan" },
    { name: "The Signature Experience", path: "/the-signature-experience" },
    { name: "Gatherings", path: "/gatherings" },
    { name: "Highlights", path: "/highlights" },
    { name: "Contact", path: "/contact-us" },
  ];
 
  return (
    <nav className="bg-green-950 text-white relative z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
        {/* Logo aligned to far left */}
          <div className="flex-shrink-0 mr-auto">
            <Link to="/">
              <img src={logo} loading="lazy" alt="Lake n River Logo" className="h-20" />
            </Link>
          </div>
  
          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-6 items-center nav-menu">
            {navLinks.map((link, idx) =>
              link.name === "Highlights" ? (
                <div
                  key={idx}
                  className="relative"
                  onMouseEnter={() => setShowActivities(true)}
                >
                  <Link
                    to="/highlights"
                    className="cursor-pointer hover:text-orange-400"
                    onClick={() => setShowActivities(false)}
                  >
                    Highlights
                  </Link>
  
                  {showActivities && (
                    <div
                      className="absolute top-[3rem] left-1/2 transform -translate-x-1/2 w-screen bg-green-950 text-white pt-12 pb-20 z-50 overflow-hidden h-56"
                      style={{ "--tw-translate-x": "-82%" }}
                      onMouseLeave={() => setShowActivities(false)}
                    >
                      <div className="max-w-7xl mx-auto grid grid-cols-3 gap-16 px-10 relative">
                        {/* Column 1 */}
                        <div>
                          <h4 className="text-sm font-bold uppercase mb-3 flex items-center gap-2">
                            <span className="w-2 h-2 bg-orange-400 inline-block rounded-sm"></span>
                            Aquatic Activities
                          </h4>
                          <ul className="space-y-2 text-sm font-light">
                            <li>
                              <Link
                                to="/backwater-canoeing"
                                className="hover:text-orange-300"
                              >
                                Backwater Canoeing
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/shikkara-boating"
                                className="hover:text-orange-300"
                              >
                                Shikkara Boating
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/kayaking"
                                className="hover:text-orange-300"
                              >
                                Kayaking
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/scenic-oasis"
                                className="hover:text-orange-300"
                              >
                                Scenic Oasis
                              </Link>
                            </li>
                          </ul>
                        </div>
  
                        {/* Column 2 */}
                        <div>
                          <h4 className="text-sm font-bold uppercase mb-3 flex items-center gap-2">
                            <span className="w-2 h-2 bg-orange-400 inline-block rounded-sm"></span>
                            Resort Attractions
                          </h4>
                          <ul className="space-y-2 text-sm font-light">
                            <li>
                              <Link
                                to="/indoor-leisure-activities"
                                className="hover:text-orange-300"
                              >
                                Indoor Leisure Activities
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/outdoor-recreational-activities"
                                className="hover:text-orange-300"
                              >
                                Outdoor Recreational Activities
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/kids-play-area"
                                className="hover:text-orange-300"
                              >
                                Kids Play Area
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/night-bbq-space"
                                className="hover:text-orange-300"
                              >
                                Night BBQ Space
                              </Link>
                            </li>
                          </ul>
                        </div>
  
                        {/* Column 3 */}
                        <div>
                          <ul className="space-y-4 text-sm font-medium">
                            {[
                              { text: "Accomodation", path: "/accommodation" },
                              {
                                text: "Cafe D' Confluence",
                                path: "/cafe-d-confluence",
                              },
                              { text: "Gallery", path: "/gallery" },
                            ].map((item, i) => (
                              <li
                                key={i}
                                className="flex items-center gap-2 text-orange-500 hover:text-orange-300"
                              >
                                <span className="w-1 h-5 bg-gradient-to-b from-pink-500 to-orange-400 rounded-sm"></span>
                                <Link to={item.path}>{item.text}</Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
  
                      {/* Logo absolutely positioned to full screen container */}
                      <img
                        src={logo}
                        alt="Logo"
                        loading="lazy"
                        className="absolute bottom-10 right-10 h-12 object-contain opacity-90"
                      />
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  key={idx}
                  to={link.path}
                  className={`hover:text-orange-400 ${
                    link.active ? "text-orange-500" : ""
                  }`}
                >
                  {link.name}
                </Link>
              )
            )}
          </div>
  
          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
  
        {/* Mobile Menu */}
        {menuOpen && (
          <div className="md:hidden px-4 pb-4 space-y-2">
            {navLinks.map((link, idx) => (
              <Link
                key={idx}
                to={link.path}
                className={`block py-2 text-white hover:text-orange-400 ${
                  link.active ? "text-orange-500" : ""
                }`}
                onClick={() => setMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};
 
export default Navbar;